import type { AxiosError } from "axios";
import { HTTP_STATUS } from "@constants/http.status.code";
import type { SigninErrorResponse, VerificationResendContext } from "../types";

export const extractVerificationResendContext = (
	error: AxiosError | SigninErrorResponse,
	formEmailAddress?: string,
): VerificationResendContext | null => {
	const axiosError = error as AxiosError;
	const errorData = (axiosError?.response?.data ?? error) as SigninErrorResponse | undefined;
	if (!errorData) return null;

	const statusCode = errorData.statusCode ?? axiosError.response?.status;
	const pendingData = errorData.data;

	if (
		statusCode === HTTP_STATUS.FORBIDDEN &&
		pendingData?.canResendVerificationLink &&
		(pendingData.emailAddress || formEmailAddress)
	) {
		return {
			emailAddress: pendingData.emailAddress || formEmailAddress || "",
		};
	}

	return null;
};

export const isLoginPendingSetupError = (error: AxiosError): boolean => {
	return extractVerificationResendContext(error) !== null;
};
